// AJAX
Helpers.ajaxSetup();

// Datatables
Helpers.defineLangDatable();
Helpers.defineInfoDatable();
Helpers.fireEventsForLoader();
